import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";
import { Mail, MessageSquare } from "lucide-react";

export const Route = createFileRoute("/de/contact")({
  head: () => ({
    meta: [
      { title: "Kontakt — Picamini.online" },
      {
        name: "description",
        content: "Kontaktieren Sie das Team von Picamini.online für Fragen, Feedback oder Vorschläge zu unseren Online-Tools.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/de/kontakt" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/contact" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/contacto" },
      { rel: "alternate", hrefLang: "de", href: "https://picamini.online/de/kontakt" },
      { rel: "alternate", hrefLang: "x-default", href: "https://picamini.online/contact" },
    ],
  }),
  component: DeContactPage,
});

function DeContactPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="de" />

      <main className="flex-1 py-12 mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 space-y-8">
        <div className="text-center space-y-3">
          <h1 className="text-3xl font-extrabold sm:text-4xl text-foreground">Kontaktieren Sie uns</h1>
          <p className="text-base text-muted-foreground leading-relaxed">
            Haben Sie Fragen, Feedback oder Ideen für neue Unterrichts-Werkzeuge? Wir freuen uns über Ihre Nachricht.
          </p>
        </div>

        <div className="surface-card p-6 sm:p-8 rounded-2xl bg-card border space-y-6 text-center">
          <div className="inline-flex size-14 items-center justify-center rounded-2xl bg-primary/10 text-primary mx-auto">
            <Mail className="size-7" />
          </div>

          <div className="space-y-2">
            <h2 className="text-xl font-bold text-foreground">E-Mail Support</h2>
            <p className="text-sm text-muted-foreground">
              Schreiben Sie uns direkt an:
            </p>
            <a
              href="mailto:support@eduzuma.com"
              className="inline-block text-lg font-bold text-primary hover:underline"
            >
              support@eduzuma.com
            </a>
          </div>

          <p className="text-xs text-muted-foreground pt-4 border-t border-border/60">
            Wir antworten in der Regel innerhalb von 24–48 Stunden an Werktagen.
          </p>
        </div>
      </main>

      <SiteFooter lang="de" />
    </div>
  );
}
